const { __ } = wp.i18n;
const i18n = {};


i18n.GALLERY = __( 'Gallery', 'meow-lightbox' );


i18n.DASHBOARD = __( 'Dashboard', 'meow-lightbox' );

i18n.ARIA = {

    ZOOM_IMAGE: __( 'Zoom image', 'meow-lightbox' ),

};

i18n.TOOLBAR = {

    PREVIOUS: __( 'Previous', 'meow-lightbox' ),
    NEXT: __( 'Next', 'meow-lightbox' ),

    ACTIONS: __( 'Actions', 'meow-lightbox' ),

    PLAY: __( 'Start Slideshow', 'meow-lightbox' ),
    PAUSE: __( 'Stop Slideshow', 'meow-lightbox' ),

    SHOW_INFO: __( 'Show Info', 'meow-lightbox' ),
    HIDE_INFO: __( 'Hide Info', 'meow-lightbox' ),

    SHOW_IMAGE: __( 'Show Image', 'meow-lightbox' ),
    SHOW_ON_MAP: __( 'Show on Map', 'meow-lightbox' ),

    SHOW_METADATA: __( 'Show Metadata', 'meow-lightbox' ),
    HIDE_METADATA: __( 'Hide Metadata', 'meow-lightbox' ),

    DOWNLOAD: __( 'Download', 'meow-lightbox' ),

    CLOSE: __( 'Close', 'meow-lightbox' ),

    IMAGE_CAPTION_AND_METADATA: __( 'Image caption and metadata', 'meow-lightbox' ),

    SHARE: __( 'Share', 'meow-lightbox' ),

    FULLSCREEN: __( 'Fullscreen', 'meow-lightbox' ),
    EXIT_FULLSCREEN: __( 'Exit Fullscreen', 'meow-lightbox' ),
    
};

i18n.EXIF = {
    CAMERA_MODEL: __( 'Camera model', 'meow-lightbox' ),
    LENS: __( 'Lens', 'meow-lightbox' ),
    FOCAL_LENGTH: __( 'Focal length', 'meow-lightbox' ),
    SHUTTER_SPEED: __( 'Shutter speed', 'meow-lightbox' ),
    APERTURE: __( 'Aperture', 'meow-lightbox' ),
    ISO: __( 'ISO', 'meow-lightbox' ),
    DATE: __( 'Date taken', 'meow-lightbox' ),
    KEYWORDS: __( 'Keywords', 'meow-lightbox' ),
    COPYRIGHT: __( 'Copyright', 'meow-lightbox' ),
    AUTHOR: __( 'Author', 'meow-lightbox' ),
};

export default i18n;

